// removed by extract-text-webpack-plugin
module.exports = {"loader":"spinner__loader__1_Mrp","load6":"spinner__load6__1unHX","round":"spinner__round__22rD_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/spinner.css
// module id = 71
// module chunks = 0